// /src/Login.js

import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from './firebase';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const userCred = await signInWithEmailAndPassword(auth, email, pw);
      onLogin(userCred.user); // Pass user up to App.js
    } catch (err) {
      setError('Login fehlgeschlagen: ' + err.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{
      maxWidth: 320,
      margin: '100px auto',
      background: '#fff',
      padding: 32,
      borderRadius: 12,
          border: '1px solid #5a55f4', // purple border around entire box

      boxShadow: '0 2px 8px rgba(0,0,0,0.07)'
    }}>
      <h2 style={{ marginBottom: 18, fontWeight: 700 }}>Login</h2>
      <div style={{ marginBottom: 10 }}>
        <input
          type="email"
          placeholder="E-Mail"
          value={email}
          onChange={e => setEmail(e.target.value)}
          style={{ width: '100%', padding: 10, fontSize: 16, borderRadius: 6, border: '1px solid #ccc' }}
        />
      </div>
      <div style={{ marginBottom: 18 }}>
        <input
          type="password"
          placeholder="Passwort"
          value={pw}
          onChange={e => setPw(e.target.value)}
          style={{ width: '100%', padding: 10, fontSize: 16, borderRadius: 6, border: '1px solid #ccc' }}
        />
      </div>
      <button type="submit" style={{
        width: '100%',
        padding: 12,
        background: '#5a55f4',
        color: '#fff',
        border: 'none',
        borderRadius: 6,
        fontWeight: 600,
        fontSize: 16,
        fontFamily: "'DM Sans', sans-serif",
    boxSizing: 'border-box', // <-- makes width match inputs exactly
        cursor: 'pointer'
      }}>
        Login
      </button>
      {error && (
        <div style={{ color: 'red', marginTop: 14, fontSize: 15 }}>
          {error}
        </div>
      )}
    </form>
  );
}